import {createSlice} from '@reduxjs/toolkit'
import {Keys} from "../../common/constants/index";

// Options: ['owner', 'client']
interface iRoles {
    roles: string[]
}

const initialState: iRoles = {
    roles: []
}
export const localStoreRoleKey = Keys.ROLES;
export const rolesSlice = createSlice({
    name: 'roles',
    initialState,
    reducers: {
        getRolesFromLocalStore: (state: iRoles) => {
            const data: string = localStorage.getItem(localStoreRoleKey) || '';

            if (!data) return;
            state.roles = [data]
        },
        getRoles: (state: any) => {
            return state.roles
        },
        setRoles: (state: any, action) => {
            state.roles = action.payload
            localStorage.setItem(localStoreRoleKey, state.roles);
        }
    }
})

export default rolesSlice.reducer

export const {
    getRoles,
    setRoles,
    getRolesFromLocalStore
} = rolesSlice.actions
